import ComponentStorageBase from './ComponentStorageBase';

class ComponentStorage extends ComponentStorageBase {
	/**
	 * @param {Object} options
	 * @param {string} options.componentKey the component identifier
	 */
	constructor(options) {
		super (options);

		this.sessionKey = 'fkd~components';
		this.initialize();
	}
}

export default ComponentStorage;
